import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Context as KitContext } from "../../context/KitContext";

import uuid from "react-uuid";
import { motion } from "framer-motion";

import { analytics } from "../../firebase";

// import "./BuildKit.css";

const preloads = [
  "/images/bg_buildkit_top.png",
  "/images/bg_buildkit_bottom.png",
  "/icons/icon_make_video_button.png",
  "/icons/icon_show_video_button.png",
  "/icons/icon_show_rain_video_button.png",
  "/icons/icon_show_webtoon_button.png",
  "/icons/icon_call_button.png",
  "/icons/icon_bg_make_button.png",
  "/icons/icon_bg_show_button.png",
  "/icons/icon_show_profile_button.png",
  "/icons/icon_show_map_button.png",
  "/images/send_mms_button.png",
  "/images/kakaotalk_send_button.png",
];

const iOS = ["iPad", "iPhone", "iPod"].indexOf(navigator.platform) >= 0;
const appURL = "https://nodamkit.web.app";

const BuildKit = () => {
  let history = useHistory();
  const { state, setKitID, saveKit } = useContext(KitContext);
  // const [saving, setSaving] = useState(false);

  useEffect(() => {
    preloads.forEach((image) => {
      new Image().src = image;
    });

    if (state.kitID === "") {
      setKitID(uuid());
    }

    // if (
    //   state.kitID !== "" &&
    //   state.videoFile !== "" &&
    //   state.imageFile !== "" &&
    //   state.saveStatus !== "OK"
    // ) {
    //   if (saving === false) {
    //     saveLink();
    //     setSaving(true);
    //   }
    // }
  }, []);

  // useEffect(() => {
  //   console.log("STATE CHANGED");
  // }, [state]);

  const sendKakaoLink = () => {
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init("a4e1b884210f1c02e6949e9e5e0c6068");
    }

    window.Kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title: "노담 KIT",
        description:
          "당신의 건강한 금연 생활을 위해 소중한 지인이 보낸 금연요청 컨텐츠입니다.",
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/nodam-campaign.appspot.com/o/image%2Fnodam_kit_closed.jpg?alt=media&token=72d1b564-1364-4807-b7e8-d071d6a51ada",
        link: {
          mobileWebUrl: appURL + "/show/" + state.kitID,
          webUrl: appURL + "/show/" + state.kitID,
        },
      },
      installTalk: true,
      buttonTitle: "KIT 열기",
    });
  };

  const saveLink = async () => {
    // need to check there are all contents
    await saveKit(
      state.kitID,
      state.videoFile,
      state.messageText,
      state.imageFile,
      state.profileFile,
      "N"
    );
  };

  return (
    <motion.div
      animate={{
        x: 0,
        opacity: 1,
      }}
      initial={{
        x: 0,
        opacity: 0,
      }}
      exit={{
        x: -300,
        opacity: 0,
      }}
      transition={{
        duration: 0.1,
      }}
    >
      <div className="main" style={{ height: "100%", position: "absolute" }}>
        <img
          src="/images/bg_buildkit_top.png"
          alt=""
          width="100%"
          height="auto"
        />
        <div
          id="message_button"
          style={{
            width: "22.88vw",
            height: "11vw",
            top: "82vw",
            left: "24vw",
            position: "absolute",
          }}
        >
          {state.videoFile === "" ? (
            <img
              src="/icons/icon_make_video_button.png"
              alt=""
              width="100%"
              height="100%"
              onClick={() => {
                history.push("/build");
              }}
            />
          ) : (
            <img
              src="/icons/icon_show_video_button.png"
              alt=""
              width="100%"
              height="100%"
              onClick={() => {
                history.push("/show_preview");
              }}
            />
          )}
        </div>
        <div
          id="rain_button"
          style={{
            width: "12vw",
            height: "19.75vw",
            top: "98vw",
            left: "20vw",
            position: "absolute",
          }}
        >
          <img
            src="/icons/icon_show_rain_video_button.png"
            alt=""
            width="100%"
            height="100%"
            onClick={() => {
              // alert("응원 메시지 준비 중입니다.");
              history.push("/show_rain_video");
            }}
          />
        </div>
        <div
          id="ebook_button"
          style={{
            width: "21.07vw",
            height: "12vw",
            top: "95vw",
            left: "34vw",
            position: "absolute",
          }}
        >
          <img
            src="/icons/icon_show_webtoon_button.png"
            alt=""
            width="100%"
            height="100%"
            onClick={() => {
              history.push("/show_webtoon");
            }}
          />
        </div>
        <div
          id="phone_button"
          style={{
            width: "15.76vw",
            height: "12vw",
            top: "107vw",
            left: "36vw",
            position: "absolute",
          }}
        >
          <a href="tel:1544-9030">
            <img
              src="/icons/icon_call_button.png"
              alt=""
              width="100%"
              height="100%"
            />
          </a>
        </div>
        <div
          id="background_button"
          style={{
            width: "18.83vw",
            height: "13vw",
            top: "82vw",
            left: "57vw",
            position: "absolute",
          }}
        >
          {state.imageFile === "" ? (
            <img
              src="/icons/icon_bg_make_button.png"
              alt=""
              width="100%"
              height="100%"
              onClick={() => {
                history.push("/background");
              }}
            />
          ) : (
            <img
              src="/icons/icon_bg_show_button.png"
              alt=""
              width="100%"
              height="100%"
              onClick={() => {
                history.push("/show_image");
              }}
            />
          )}
        </div>
        <div
          id="sticker_button"
          style={{
            width: "24.47vw",
            height: "11vw",
            top: "98vw",
            left: "57vw",
            position: "absolute",
          }}
        >
          <img
            src="/icons/icon_show_profile_button.png"
            alt=""
            width="100%"
            height="100%"
            onClick={() => {
              history.push("/show_profile");
            }}
          />
        </div>
        <div
          id="map_button"
          style={{
            width: "22.10vw",
            height: "12vw",
            top: "108vw",
            left: "57vw",
            position: "absolute",
          }}
        >
          <img
            src="/icons/icon_show_map_button.png"
            alt=""
            width="100%"
            height="100%"
            onClick={() => {
              history.push("/show_map");
            }}
          />
        </div>
        <div
          id="bottom"
          style={{ height: "100%", position: "absolute", width: "100%" }}
        >
          {state.videoFile === "" || state.imageFile === "" ? (
            <img
              style={{ position: "relative", top: "-4px" }}
              src="/images/bg_buildkit_bottom.png"
              alt=""
              width="100%"
              height="auto"
            />
          ) : (
            <div
              style={{
                position: "relative",
                top: "-4px",
                background: "white",
                height: "200px",
                width: "100%",
              }}
            >
              <img
                style={{
                  top: "0px",
                  position: "relative",
                }}
                alt=""
                src="/images/send_mms_button.png"
                width="auto"
                height="80px"
                onClick={async () => {
                  // if (state.saveStatus !== "OK") {
                  //   alert(
                  //     "키트가 서버에 저장되지 않았습니다. 잠시만 기다려주세요."
                  //   );
                  //   return;
                  // }
                  if (state.saveStatus !== "OK") {
                    await saveLink();
                  }
                  // await new Promise((resolve) => setTimeout(resolve, 2000));

                  analytics.logEvent("MMS send");
                  if (iOS) {
                    window.open("sms:&body=" + appURL + "/show/" + state.kitID);
                  } else {
                    window.open("sms:?body=" + appURL + "/show/" + state.kitID);
                  }
                }}
              />
              <img
                style={{
                  top: "0px",
                  position: "relative",
                }}
                alt=""
                src="/images/kakaotalk_send_button.png"
                width="auto"
                height="80px"
                onClick={async () => {
                  // save to database & send
                  // if (state.saveStatus !== "OK") {
                  //   alert(
                  //     "키트가 서버에 저장되지 않았습니다. 잠시만 기다려주세요."
                  //   );
                  //   return;
                  // }
                  // await new Promise((resolve) => setTimeout(resolve, 2000));
                  if (state.saveStatus !== "OK") {
                    await saveLink();
                  }
                  analytics.logEvent("KAKAO send");
                  sendKakaoLink();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default BuildKit;
